import { Component, DestroyRef, PLATFORM_ID, inject, input, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-platform-loading-state',
  standalone: true,
  template: `
    <section class="loading-state" role="status" aria-live="polite" aria-busy="true">
      <span class="loading-state__spinner" aria-hidden="true"></span>
      <strong>{{ label() }}</strong>
      <p>{{ slow() ? 'This is taking longer than usual. Please wait…' : detail() }}</p>
    </section>
  `,
  styles: `
    :host { display: block; }
    .loading-state {
      display: grid; justify-items: center; align-content: center; gap: 12px;
      min-height: 60vh; padding: 32px 20px; text-align: center;
      color: var(--platformAdmin-text, var(--text-primary));
    }
    strong { font-size: 16px; font-weight: 600; }
    p { margin: 0; max-width: 32rem; font-size: 14px; color: var(--platformAdmin-muted, var(--text-muted)); }
    .loading-state__spinner {
      width: 40px; height: 40px; border-radius: 50%;
      border: 3px solid var(--border-default);
      border-top-color: var(--workspace-primary, #2fc1f1);
      animation: platform-loading-spin 0.8s linear infinite;
    }
    @keyframes platform-loading-spin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) { .loading-state__spinner { animation: none; } }
  `,
})
export class PlatformLoadingState {
  readonly label = input('Opening Platform Admin…');
  readonly detail = input('Checking your session securely.');
  protected readonly slow = signal(false);

  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      const timer = setTimeout(() => this.slow.set(true), 4000);
      inject(DestroyRef).onDestroy(() => clearTimeout(timer));
    }
  }
}
